<div class="home" data-testid="decim-home-container">
  <div class="top">
    <div class="top-bg">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-full.png" height="180px" />
      <h3>Le Fonds DECIM vise à améliorer l’accès à une énergie fiable et abordable ainsi qu’aux équipements numériques pour les communautés mal desservies et les groupes marginalisés à Madagascar.</h3>

      <div class="top-images">
        <img class="top-image" src="https://oes-hosted-images-public.s3.amazonaws.com/decim-1.jpg" />
        <img class="top-image" src="https://oes-hosted-images-public.s3.amazonaws.com/decim-2.jpg" />
        <img class="top-image" src="https://oes-hosted-images-public.s3.amazonaws.com/decim-3.jpg" />
      </div>


      <div class="bottom">
        <div class="bottom-logo-box">
          <h4 class="mb-0">INITIÉ PAR</h4>
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-meh.jpg" width="80px" style="margin-right: 15px;" />
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-mndpt.png" width="170px" />
          </div>
        </div>
        <div class="bottom-logo-box">
          <h4>GESTIONNAIRE DE FONDS</h4>
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-bamboo-logo.png" width="260px" />
          </div>
        </div>
        <div class="bottom-logo-box">
          <h4>PARTENAIRE</h4>
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-bred.png" width="190px" />
          </div>
        </div>
        <div class="bottom-logo-box">
          <h4>FINANCÉ PAR</h4>
          <div class="bottom-logos">
            <img src="https://oes-hosted-images-public.s3.amazonaws.com/decim-wb.jpg" width="300px" />
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
